<template>
  <ag-grid-vue
      ref="agGridTable"
      :gridOptions="gridOptions"
      class="ag-theme-material w-100 py-2 ag-grid-table"
      :columnDefs="columnDefs"
      :auto-group-column-def="autoGroupColumnDef"
      :defaultColDef="defaultColDef"
      :rowData="data"
      :rowSelection="rowSelection"
      :rowMultiSelectWithClick="computeRowMultiSelectWithClick"
      :animateRows="true"
      :pagination="false"
      :suppressPaginationPanel="true"
      :quickFilterText="search"
      @rowClicked="onRowClicked"
      @cellClicked="onCellClicked"
      @selectionChanged="onSelectionChanged"
      @download="$emit('download', $event)"
      @rowSelected="$emit('rowSelected', $event)"
      :sideBar="sideBarDef"
      rowHeight="30"
      headerHeight="35"
      floatingFiltersHeight="35"
      @grid-ready="onGridReady"
  >
  </ag-grid-vue>
</template>

<script>
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'

import { AgGridVue } from 'ag-grid-vue'
import { ModuleRegistry } from '@ag-grid-community/core';
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { RowGrouping } from '@ag-grid-enterprise/row-grouping';
import { SideBar } from '@ag-grid-enterprise/side-bar';

export default {
  name: "t-grid",
  components: {
    AgGridVue,
  },
  props: {
    columnDefs: {
      type: Array,
      required: true,
    },
    autoGroupColumnDef: {
      type: Object,
      required: false,
    },
    defaultColDef: {
      type: Object,
      default: () => {
        return {
          sortable: true,
          resizable: true,
          filter: 'agSetColumnFilter',
          floatingFilter: true,
        }
      }
    },
    gridOptions: {
      type: Object,
      default: () => {
        return {}
      }
    },
    autoSize: {
      type: Boolean,
      default: false,
    },
    rowSelection: {
      type: String,
      default: "multiple",
    },
    rowMultiSelectWithClick: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    search: {
      required: false,
      default: '',
    }
  },
  data() {
    return {
      gridApi: null,
      modules: [
        RowGrouping,
        SideBar,
      ],
      sideBarDef: {
        toolPanels: ['columns'],
      },
    };
  },
  computed: {
    computeRowMultiSelectWithClick() {

      if (this.rowMultiSelectWithClick) {
        return true;
      }

      const hasCheckbox = Boolean(this.columnDefs.find(item => item.checkboxSelection === true));

      if (hasCheckbox) {
        return true;
      }

      if (this.autoGroupColumnDef) {
        if (this.autoGroupColumnDef.cellRendererParams && this.autoGroupColumnDef.cellRendererParams.checkbox) {
          return true;
        }
      }

      return false;
    }
  },
  watch: {
    loading(newValue) {
      const setLoadingState = (value) => {
        // if (this.gridApi && !this.gridApi.isDestroyed()) {
        //   if (value === true) {
        //     this.gridApi.showLoadingOverlay();
        //   } else {
        //     this.gridApi.hideOverlay();
        //   }
        // } else {
        //   setTimeout(() => setLoadingState(value), 500);
        // }
      };
  
      setLoadingState(newValue);
    },
  },
  mounted () {
    if (this.autoSize) {
      this.autoResizeGrid();
    }

    this.$emit('ready');
    this.resizeListener();
  },
  created () {
    ModuleRegistry.registerModules([
      ClientSideRowModelModule
    ]);

    if (this.autoSize) {
      this.autoResizeGridOnWindowResize();
    }
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.$emit('update:gridApi', this.gridApi);
    },
    resizeListener() {
      this.checkWindowsResizeValue();

      window.addEventListener('resize', () => {
        this.checkWindowsResizeValue();
      });
    },
    checkWindowsResizeValue() {
      if (this.$refs.agGridTable) {
        if (Math.round(window.devicePixelRatio * 100) > 100) {
          return this.$refs.agGridTable.$el.classList.add('force-full-height')
        }

        return this.$refs.agGridTable.$el.classList.remove('force-full-height');
      }
    },
    autoResizeGridOnWindowResize() {
      window.addEventListener("resize", () => this.autoResizeGrid());
    },
    autoResizeGrid() {
      this.$nextTick(() => {
        const gridEl = this.$refs.agGridTable && this.$refs.agGridTable.$el;

        if (this.gridApi &&
          !this.gridApi.isDestroyed() &&
          gridEl &&
          gridEl.offsetWidth > 0
        ) {
          this.gridApi.sizeColumnsToFit();
        } else {
          setTimeout(() => this.autoResizeGrid(), 500);
        }
      });
    },
    onRowClicked(params) {
      if (!this.isCheckBox(params.event.target)) {
        this.$emit('rowClicked', params);
      }
    },
    onCellClicked(params) {
      this.$emit('cellClicked', params);
    },
    onSelectionChanged(params) {
      this.$emit('onSelectionChanged', params);
    },
    isCheckBox(target) {
      return target.innerHTML.includes('ag-checkbox-input');
    }
  },
}
</script>

<style lang="scss">
  .ag-theme-material {
    font-size: 12px;

    @media (min-height: 850px) {
      &:not(.force-full-height) {
        &.xl {
          height: calc(var(--vh, 1vh) * 100 - 10rem);
        }

        &.lg {
          height: calc(var(--vh, 1vh) * 100 - 13.1rem);
        }

        &.md-plus {
          height: calc(var(--vh, 1vh) * 100 - 16.6rem);
        }

        &.md {
          height: calc(var(--vh, 1vh) * 100 - 18.8rem);
        }

        &.sm {
          height: calc(var(--vh, 1vh) * 100 - 47.2rem);
        }
      }
    }

    .ag-header-row {
      color: #262626;
    }

    .ag-row-odd {
      background: #f8f8f8 !important;
    }

    .ag-checkbox-input-wrapper.ag-checked::after {
      color: #110D0D;
    }

    .ag-header-cell {
      padding: 0 12px;
    }

    .ag-cell {
      line-height: 30px;
      padding: 0 12px;
    }

    .ag-input-field {
      .ag-input-wrapper {
        .ag-input-field-input {
          border: 1px solid #c7c7c7;
          height: 24px;
          border-radius: 3px;
          padding: 2px 4px;
        }
      }
    }

    .ag-filter-filter {
      margin: 0 !important;
    }

    .ag-cell-wrapper > *:not(.ag-cell-value):not(.ag-group-value) {
      height: 100%;
    }

    .ag-ltr {
      .ag-floating-filter-button {
        margin-left: 6px;
      }
    }
  }

</style>